export enum OrderByDirection {
  'Desc' = 'DESC',
  'Asc' = 'ASC',
}

export interface IPagination {
  orderBy: string,
  orderByDirection: `${OrderByDirection}`
  limit: number,
  page: number,
  offset: number,
}
